import { ORDER_HISTORY_EVENT_VALUES, valueMap } from "../platform/domain-values";

export { ORDER_HISTORY_EVENT_VALUES };

export type OrderHistoryEventType = (typeof ORDER_HISTORY_EVENT_VALUES)[number];

export const ORDER_HISTORY_EVENTS = valueMap(ORDER_HISTORY_EVENT_VALUES);

export function isOrderHistoryEventType(value: string): value is OrderHistoryEventType {
  return (ORDER_HISTORY_EVENT_VALUES as readonly string[]).includes(value);
}
